/**
 * Format price for display
 * This utility can be used on both client and server
 */
export function formatPrice(priceInCents: number, currency = 'USD'): string {
	return new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency,
	}).format(priceInCents / 100)
}

/**
 * Format price as a simple number (no currency symbol)
 */
export function formatAmount(priceInCents: number): string {
	return (priceInCents / 100).toFixed(2)
}

/**
 * Convert dollar amount to cents
 */
export function dollarsToCents(dollars: number): number {
	return Math.round(dollars * 100)
}

/**
 * Convert cents to dollars
 */
export function centsToDollars(cents: number): number {
	return cents / 100
}
